module.exports = __webpack_public_path__ + "img/cju_gallery8.9ade3fc1.jpg";